<template>
	<div class="fu-editor box">
		<!-- Types -->
		<div class="btn-group btn-group-toggle btn-group-block mb-3" role="group" v-if="smsAvailable">
			<button type="button" class="btn btn-default col" :class="{ 'active': type === 'wa' }" @click="type = 'wa'">WhatsApp</button>
			<button type="button" class="btn btn-default col" :class="{ 'active': type === 'sms' }" @click="type = 'sms'">SMS</button>
		</div>
		<!-- Content -->
		<div class="fu-editor__content" v-if="(type === 'sms' && smsIntegrated) || type === 'wa'">
			<!-- Save SMS Gateway -->
			<div class="modal-empty-data text-center" v-if="type === 'sms' && smsGateways.length === 0">
				<div class="mb-3">Select SMS Gateway Account for this product</div>
				<div class="input-group custom-input-group mx-auto">
					<multiselect
						class="form-control"
						v-model="selectedSmsGateway"
						placeholder="Select SMS Gateway Account"
						label="name"
						track-by="name"
						:options="smsGatewayOptions"
						:preselect-first="true"
						:allow-empty="false"
						:show-labels="false">
					</multiselect>
					<div class="input-group-append">
						<button type="button" class="input-group-text btn btn-default" @click="saveProductSmsGateways">{{ $t('Save') }}</button>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="fu-editor__description" v-if="description !== ''">{{ description }}</div>
				<div class="fu-editor__fields">
					<!-- WhatsApp -->
					<textarea
						rows="8"
						class="fu-editor__textarea form-control"
						:value="value"
						v-on:input="updateValue"
						v-if="type === 'wa' && !isValueObject"
						ref="content">
					</textarea>

					<!-- WhatsApp -->
					<textarea
						rows="8"
						class="fu-editor__textarea form-control"
						:value="autotext.format"
						@input="updateAutoTextFormat"
						v-if="type === 'wa' && isValueObject"
						ref="content">
					</textarea>

					<!-- SMS -->
					<textarea
						rows="8"
						class="fu-editor__textarea form-control"
						:value="format"
						v-on:input="updateFormat"
						v-if="type === 'sms'"
						ref="contentSms">
					</textarea>
				</div>

				<!-- Emoji Picker -->
				<emoji-picker
					@select="addEmoji"
					v-if="emojiPickerVisible">
				</emoji-picker>

				<!-- Footer -->
				<div class="fu-editor__footer">
					<div class="flex-center flex-fill">
						<!-- Tokens -->
						<div class="fu-editor__tokens mr-3">
							<div class="input-group">
								<multiselect
									class="form-control"
									placeholder="Select Autotext"
									v-model="selectedToken"
									:options="followUpContents"
									:show-labels="false"
									:preselect-first="true"
									group-values="options"
									group-label="type"
									:group-select="false"
									track-by="key"
									label="label">
								</multiselect>
								<div class="input-group-append">
									<button type="button" class="input-group-text btn btn-default" @click="insertToken" v-if="type === 'wa'">Insert</button>
									<button type="button" class="input-group-text btn btn-default" @click="insertTokenSms" v-if="type === 'sms'">Insert</button>
								</div>
							</div>
						</div>
						<!-- Emoji Picker Toggle -->
						<button
							type="button"
							class="btn btn-default"
							title="Insert Emoji"
							v-tooltip="'Emoji Picker'"
							@click="emojiPickerVisible = !emojiPickerVisible">😃</button>
						<!-- Upload Image -->
						<image-uploader
							class="ml-3 cur-p"
							:btn-style="'default'"
							:multiple="false"
							:resize="false"
							@uploaded="setImage"
							v-if="showUploadImage">
						</image-uploader>
						<!-- Image Preview -->
						<a :href="image" target="_blank" v-if="image !== ''">
							<img class="btn fu-image-preview p-0 ml-3" :src="image">
						</a>
						<!-- Remove Image -->
						<button
							type="button"
							class="btn btn-default ml-3"
							@click="clearImage"
							v-if="image !== ''">Remove Image</button>
					</div>
					<!-- Actions -->
					<div class="fu-editor__actions">
						<div class="text-right">
							<button type="button" class="btn btn-default fu-editor__reset" @click="reset" v-if="type === 'wa'">Reset WhatsApp to default</button>
							<button type="button" class="btn btn-default fu-editor__reset" @click="resetSms" v-if="type === 'sms'">Reset SMS to default</button>
						</div>
					</div>
				</div>

				<!-- Schedule - WA -->
				<div class="fu-editor__schedule" v-if="isShowWaSchedule">
					<label><b>Schedule</b></label>
					<div class="row">
						<div class="col-md-6">
							<div class="row">
								<div class="col-md-6">
									<!-- Toggle -->
									<div class="input-group">
										<label class="label-toggle d-block">
											<input type="checkbox" class="toggle" v-model="autotext.enabled" v-on:change="updateAutoText">
											<div class="toggle-btn d-inline-block"></div>
											<span class="label-toggle-text">Enable Auto Send</span>
										</label>
									</div>
								</div>
								<div class="col-md-6">
									<!-- WA Gateways -->
									<multiselect
										class="form-control ellipsis"
										label="value"
										v-model="selectedWAGateway"
										:options="waGatewayOptions"
										:custom-label="getWaLabel"
										:show-labels="false"
										:allow-empty="true"
										:preselect-first="false"
										:placeholder="'Select Gateway'">
									</multiselect>
								</div>
							</div>
						</div>
						<div class="col-md-6" v-if="autotext.schedule.type !== 'immediately'">
							<div class="row">
								<div class="col-md-6">
									<!-- Day -->
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text">Day <i class="material-icons ml-1" v-tooltip="'Hari setelah order masuk, contoh:<br>Day 1: dikirim pada hari order diterima<br>Day 2: dikirim 1 hari setelah order diterima (besoknya)'">info</i></span>
										</div>
										<multiselect
											class="form-control"
											v-model="autotext.schedule.day"
											:options="days"
											:show-labels="false"
											:allow-empty="false"
											:preselect-first="true"
											:placeholder="''">
										</multiselect>
									</div>
								</div>
								<div class="col-md-6">
									<!-- Hour -->
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text">Hour <i class="material-icons ml-1" v-tooltip="'Jam pengiriman SMS, contoh:<br>Hour 10: dikirim jam 10 pagi<br>Hour 14: dikirim jam 2 siang'">info</i></span>
										</div>
										<multiselect
											class="form-control"
											v-model="autotext.schedule.hour"
											:options="hours"
											:show-labels="false"
											:allow-empty="false"
											:preselect-first="true"
											:placeholder="''">
										</multiselect>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Schedule - SMS -->
				<div class="fu-editor__schedule" v-if="type === 'sms'">
					<label><b>Schedule</b></label>
					<div class="row">
						<div class="col-md-6">
							<div class="input-group">
								<label class="label-toggle d-block">
									<input type="checkbox" class="toggle" :checked="enabled" v-on:change="updateEnabled">
									<div class="toggle-btn d-inline-block"></div>
									<span class="label-toggle-text">Enable Auto Send</span>
								</label>
							</div>
						</div>
						<div class="col-md-6" v-if="schedule.type !== 'immediately'">
							<div class="row">
								<div class="col-md-6">
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text">Day <i class="material-icons ml-1" v-tooltip="'Hari setelah order masuk, contoh:<br>Day 1: dikirim pada hari order diterima<br>Day 2: dikirim 1 hari setelah order diterima (besoknya)'">info</i></span>
										</div>
										<multiselect
											class="form-control"
											:value="schedule.day"
											:options="days"
											:show-labels="false"
											:preselect-first="true"
											:placeholder="''"
											@select="updateDay">
										</multiselect>
									</div>
								</div>
								<div class="col-md-6">
									<div class="input-group">
										<div class="input-group-prepend">
											<span class="input-group-text">Hour <i class="material-icons ml-1" v-tooltip="'Jam pengiriman SMS, contoh:<br>Hour 10: dikirim jam 10 pagi<br>Hour 14: dikirim jam 2 siang'">info</i></span>
										</div>
										<multiselect
											class="form-control"
											:value="schedule.hour"
											:options="hours"
											:show-labels="false"
											:preselect-first="true"
											:placeholder="''"
											@select="updateHour">
										</multiselect>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-empty-data text-center" v-else>
			<div class="mb-3">Integrate your SMS Gateway account to start using the auto sms feature</div>
			<router-link class="btn btn-primary" to="/settings/sms">Integrate SMS Gateway</router-link>
		</div>
	</div>
</template>

<script>
import Loader from './Loader.vue';
import ImageUploader from './ImageUploader.vue';
import { followUpTokens, followUpContents } from '@/lib/statics';
import { duplicateVar } from '@/lib/helper';

const waOptions = {
	waboxapp: 'Waboxapp',
	woowa: 'Woowa',
	woonotif: 'WooNotif',
};

const EmojiPicker = () => ({
	component: import(/* webpackChunkName: "emoji" */ '@/components/EmojiPicker.vue'),
	loading: Loader,
});

export default {
	name: 'autoTextEditor',
	props: {
		content: {}, // Default WA Content
		description: {},
		value: {},
		category: {},
		smsAvailable: {},
		defaultText: {}, // Default SMS Content
		enabled: {},
		format: {},
		schedule: {},
		smsIntegrated: {},
		smsGatewayOptions: {},
		smsGateways: {},
		waGatewayOptions: {},
		waGateways: {},
		autotext: {},
		user: {
			type: Object,
		},
		waOptions,
	},
	components: {
		EmojiPicker,
		ImageUploader,
	},
	data() {
		return {
			followUpTokens,
			followUpContents,
			selectedToken: null,
			type: 'wa',
			days: [1, 2, 3, 4, 5, 6, 7, 8],
			hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
			selectedSmsGateway: '',
			selectedWAGateway: null,
			emojiPickerVisible: false,
			image: '',
		};
	},
	methods: {
		updateValue(event) {
			const value = event.target.value;
			this.$emit('input', value);
		},
		reset() {
			if (typeof this.content === 'string') {
				const content = this.content.slice();
				this.$emit('input', content);
			} else {
				const content = duplicateVar(this.content);
				const format = content.format;
				this.autotext.format = format;
				this.updateAutoText();
			}
		},
		insertToken() {
			const token = this.selectedToken.value;
			this.insertText(token);
		},
		insertText(text) {
			const field = this.$refs.content;
			if (field) {
				const startPos = field.selectionStart;
				const endPos = field.selectionEnd;
				const oldContent = field.value.slice();
				const newContent = oldContent.substring(0, startPos) + text + oldContent.substring(endPos, oldContent.length);
				if (typeof this.content === 'string') {
					this.$emit('input', newContent);
				} else {
					this.autotext.format = newContent;
					this.updateAutoText();
				}
			}
		},
		updateEnabled() {
			const value = !this.enabled;
			this.$emit('update:enabled', value);
		},
		updateAutoText() {
			this.$emit('update:autotext', this.autotext);
		},
		updateFormat(event) {
			const value = event.target.value;
			this.$emit('update:format', value);
		},
		resetSms() {
			const text = duplicateVar(this.defaultText);
			const format = text.format;
			this.$emit('update:format', format);
		},
		insertTokenSms() {
			const field = this.$refs.contentSms;

			const startPos = field.selectionStart;
			const endPos = field.selectionEnd;

			const token = this.selectedToken.value;
			const oldContent = field.value.slice();

			const newContent = oldContent.substring(0, startPos) + token + oldContent.substring(endPos, oldContent.length);

			this.$emit('update:format', newContent);
		},
		updateDay(value) {
			// const value = event.target.value;
			this.schedule.day = value;
			const schedule = this.schedule;
			this.$emit('update:schedule', schedule);
		},
		updateHour(value) {
			// const value = event.target.value;
			this.schedule.hour = value;
			const schedule = this.schedule;
			this.$emit('update:schedule', schedule);
		},
		saveProductSmsGateways() {
			this.$emit('saveProductSmsGateways', this.selectedSmsGateway.value);
		},
		updateAutoTextFormat(event) {
			const format = event.target.value;
			this.autotext.format = format;
			this.updateAutoText();
		},
		updateWAGateways() {
			const waGateways = this.selectedWAGateway ? [this.selectedWAGateway.value] : [];
			this.$emit('updateWaGateways', waGateways);
		},
		initData() {
			// if ((!this.waGateways && this.waGatewayOptions.length > 0) || (this.waGateways && this.waGateways.length === 0)) {
			// this.selectedWAGateway = this.waGatewayOptions[0];
			if (this.waGateways && this.waGateways.length > 0 && this.waGatewayOptions.length > 0) {
				const waGatewayValue = this.waGateways[0];
				const waGateway = this.waGatewayOptions.find(option => option.value === waGatewayValue);
				if (waGateway) {
					this.selectedWAGateway = waGateway;
				}
			}
			this.checkImage();
		},
		addEmoji(emoji) {
			this.insertText(emoji.native);
		},
		getWaLabel(option) {
			return waOptions[option.value];
		},
		setImage(imageUrl) {
			this.image = imageUrl;
			this.autotext.image = imageUrl;
			this.updateAutoText();
		},
		clearImage() {
			this.image = '';
			this.autotext.image = '';
			this.updateAutoText();
		},
		checkImage() {
			this.image = this.autotext.image || '';
		},
	},
	created() {
		this.initData();
	},
	computed: {
		isAdmin() {
			return this.user && this.user.is_admin;
		},
		isValueObject() {
			return typeof duplicateVar(this.value) === 'object';
		},
		isShowWaSchedule() {
			return this.type === 'wa' && this.autotext.schedule && this.smsAvailable && this.waGatewayOptions.length > 0;
		},
		showUploadImage() {
			const isHasIntegratedGateway = this.waGatewayOptions.length > 0;
			return isHasIntegratedGateway && this.category !== 'order_confirmation_redirect' && this.image === '';
		},
	},
	watch: {
		category() {
			if (!this.smsAvailable) {
				this.type = 'wa';
			}
		},
		'autotext.schedule.day': function () {
			this.updateAutoText();
		},
		'autotext.schedule.hour': function () {
			this.updateAutoText();
		},
		selectedWAGateway() {
			this.updateWAGateways();
		},
		autotext() {
			this.checkImage();
		},
	},
};
</script>

<style lang="scss">
@import '../assets/scss/modules/_variables.scss';

.fu-editor {
	margin-bottom: 0;
	border-top: 0;

	&.box {
		border: 1px solid $color__border;
		border-top: 0;
		box-shadow: none !important;
	}
}

.fu-editor__description {
	margin-bottom: 1em;
}

.fu-editor__footer {
	display: flex;
	margin-top: 1em;
	justify-content: space-between;

	.btn {
		padding-top: 0;
		padding-bottom: 0;
		height: 40px;
		line-height: 38px;
	}
}

// .fu-editor__actions {
	// display: flex;
	// width: 40%;
// }

.fu-editor__schedule {
	margin-top: 1em;
	padding-top: 1em;
	border-top: 1px solid #ddd;

	.label-toggle {
		display: block;
		height: 40px;
		// margin-right: 1em;
		margin-bottom: 0;
		padding-top: .5em;
		cursor: pointer;

		.toggle-btn {
			margin-right: 5px;
		}
	}
}
</style>
